import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from "@/components/auth/Login";
import LoginHadafmandi from "@/components/auth/hadafmandi/CallCenterLogin";
import Password from "@/components/auth/Password";
import Otp from "@/components/auth/Otp";
import forget from "@/components/auth/Forget";
import NewPassword from "@/components/auth/NewPassword";
import CheckLogin from "@/components/auth/CheckLogin";
import Error404View from '../views/Error404View.vue'
import Error503View from '../views/Error503View.vue'
import Error403View from '../views/Error403View.vue'

/*import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import axios from 'axios'*/
const hadafmandi = window.appConfig.hadafmandi

const routes = [
    {
        path: '/',
        name: 'HomeView',
        component: HomeView,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'پنل راهبر',
            withoutLayout: false
        },
    },

    {
        path: '/admin',
        meta: {title: 'پنل راهبر', requiresAuth: true , permission:'PREFERENCES',withoutLayout: false},
        children: [
            {
                path: 'users/users',
                name: 'UsersComponent',
                meta: {requiresAuth: true,permission:'PREFERENCES', title: 'لیست کاربران'},

                component: () => import('../components/admin/Users')
            },
            {
                path: 'users/users-portal',
                name: 'UsersPortal',
                meta: {
                    requiresAuth: true,
                    title: 'کاربران پرتال',permission: 'PREFERENCES',
                    requiredFeatures: ['portal']
                },

                component: () => import('../components/admin/UsersPortal')
            },
            {
                path: 'users/users-role',
                name: 'UsersRole',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'نقش کاربران',},

                component: () => import('../components/admin/UsersRole')
            },
            {
                path: 'users/bans',
                name: 'Bans',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مسدودیت ها'},

                component: () => import('../components/admin/BansView')
            },
            {
                path: 'formManage',
                name: 'SettingComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'تنظیمات'},

                component: () => import('../components/admin/Setting')
            },

            {
                path: 'api',
                name: 'ApisComponent',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title: 'api ها',
                    permission: 'PREFERENCES',
                },

                component: () => import('../components/admin/Apis')
            },
            {
                path: 'api-connections',
                name: 'ApiConnections',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title: 'اتصال api ها',
                    permission: 'PREFERENCES',
                },

                component: () => import('../components/admin/ApiConnections')
            },
            {
                path: 'log-system',
                name: 'LogsSystem',
                meta: {requiresAuth: true,
                    permission: 'PREFERENCES', title: 'لاگ های سیستم'},
                component: () => import('../components/admin/SystemLogs')
            },

            {
                path: 'financial',
                name: 'FinancialComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: ' فهرست پرداخت ها '},

                component: () => import('../components/admin/Financial')
            },
            {
                path: 'work-flow',
                name: 'WorkFlow',
                meta: {
                    requiresAuth: true,
                    requiredFeatures: ['workflow_management'],
                    permission: 'PREFERENCES', title: 'گردش کارها'
                },

                component: () => import('../components/admin/workflow/WorkFlow.vue')
            },
            {
                path: 'work-flow/diagram/:id?',
                name: 'DiagramComponent',
                meta: {title: 'نمودار گردش کار', requiresAuth: true,permission: 'PREFERENCES',},

                component: () => import('../components/admin/workflow/Diagram.vue')
            },
            {
                path: 'licences',
                name: 'Licences',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لایسنس ها'},

                component: () => import( '../components/admin/Licences')
            },
            {
                path: 'bills/:id?',
                name: 'BillsComponent',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'پرداخت ها'},

                component: () => import( '../components/admin/Bills')
            },
            {
                path: 'call-center',
                name: 'CallCenter',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مرکز تماس'},

                component: () => import( '../components/admin/CallCenter')
            },
            {
                path: 'queues',
                name: 'Queues',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مدیریت صف ها'},

                component: () => import( '../components/admin/Queues')
            },
            /*{
                path: 'zones',
                name: 'zonesManagement',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'مدیریت مناطق'},

                component: () => import( '../components/admin/zonesManagement/ZonesManagement')
            },*/
            {
                path: 'logs/telegram',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های تلگرام'},
                name: 'TelegramLogs',
                component: () => import('../components/management/logs/TelegramLogs')
            },
            {
                path: 'logs/whatsapp',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های واتس آپ'},
                name: 'WhatsappLogs',
                component: () => import('../components/management/logs/WhatsappLogs')
            },
            {
                path: 'logs/instagram',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های اینستاگرام'},
                name: 'InstagramLogs',
                component: () => import('../components/management/logs/InstagramLogs')
            },
            {
                path: 'logs/bale',
                meta: {requiresAuth: true,permission: 'PREFERENCES', title: 'لاگ های بله'},
                name: 'BaleLogs',
                component: () => import('../components/management/logs/BaleLogs')
            },

            {
                path: 'chat/hi',
                meta: {requiresAuth: true, title: 'صفحه چت'},
                name: 'ChatHi',
                component: () => import('../components/admin/ChatHi')
            },


        ]
    },

    {
        path: '/management',
        meta: {title: 'مدیریت درخواست‌ها', requiresAuth: true,withoutLayout: false},
        children: [
            {
                path: 'dashboard',
                meta: {title: 'داشبورد', requiresAuth: true},
                name: 'DashboardManagement',
                component: () => import('../components/management/Dashboard'),

            },
            {
                path: 'profile-setting',
                name: 'ProfileSetting',
                meta: {title: 'تنظیمات پروفایل', requiresAuth: true},

                component: () => import('../components/admin/ProfileSetting')
            },
            {
                path: 'user-logs',
                name: 'UserLogs',
                meta: {title: 'گزارش فعالیت کاربران', requiresAuth: true},
                component: () => import('../components/management/UserLogs.vue')
            },
            {
                path: 'request-status',
                name: 'RequestStatus',
                meta: {title: 'وضعیت‌های درخواست', requiresAuth: true, permission:'TASK_STATUS_LIST'},

                component: () => import( '../components/management/RequestStatus')
            },
            {
                path: 'request-types',
                name: 'RequestType',
                meta: {title: 'گروه‌های درخواست', requiresAuth: true, permission:'TASK_TYPE_LIST'},

                component: () => import( '../components/admin/RequestTypes')
            },
            {
                path: 'tags',
                name: 'TagsComponent',
                meta: {title: 'برچسب‌ها', requiresAuth: true, permission:'TAG_LIST'},

                component: () => import( '../components/admin/Tags')
            },
            {
                path: 'faq/list',
                name: 'FaqComponent',
                meta: {title: 'پرسش‌های پرتکرار', requiresAuth: true, permission:'FAQ_LIST'},
                component: () => import( '../components/admin/Faq')
            },
            {
                path: 'faq/category',
                name: 'FaqCatComponent',
                meta: {title: 'دسته‌بندی پرسش‌ها', requiresAuth: true, permission:'FAQ_CATEGORY_LIST'},
                component: () => import( '../components/admin/FaqCat')
            },
            {
                path: 'departments',
                name: 'DepartmentsComponent',
                meta: {title: 'دپارتمان‌ها', requiresAuth: true, permission:'DEPARTMENT_LIST'},
                component: () => import( '../components/management/Departments')
            },
            {
                path: 'contracts/:id?',
                name: 'ContractsComponent',
                meta: {title: 'قراردادها', requiresAuth: true, permission:'CONTRACT_LIST'},
                component: () => import( '../components/management/ContractComponent')
            },
            {
                path: 'meeting/:id?',
                name: 'MeetingManagement',
                meta: {title: 'مدیریت جلسات', requiresAuth: true, permission:'CONTRACT_LIST'},
                component: () => import( '../components/management/MeetingManagement')
            },
            {
                path: 'smart-documents/documents',
                name: 'SmartDocuments',
                meta: {title: 'مدیریت اسناد', requiresAuth: true},
                component: () => import('../components/management/SmartDocuments.vue')
            },
            {
                path: 'smart-documents/metadata',
                name: 'MetadataManagement',
                meta: {title: 'مدیریت متا دیتا', requiresAuth: true},
                component: () => import('../components/management/MetadataManagement.vue')
            },
            {
                path: 'ai-doc-check',
                name: 'AiDocCheck',
                meta: {requiresAuth: true, permission: 'PREFERENCES', requiredFeatures: ['ai_doc_check'], title: 'مشخصات اسنادی'},

                component: () => import('../components/admin/AiDocCheck')
            },
            {
                path: 'documents',
                name: 'DocumentManagement',
                meta: {title: 'داکیومنت', requiresAuth: true},
                component: () => import('../components/management/DocumentManagement.vue')
            },
            {
                path: 'tasks/:id?',
                meta: {title: 'درخواست‌ها', requiresAuth: true , permission:'TASK_LIST'},
                name: 'TasksComponent',
                component: () => import('../components/management/TasksComponent')
            },
            {
                path: 'new-request/:id?',
                meta: {title: 'ثبت درخواست جدید', requiresAuth: true},
                name: 'NewRequestView',
                component: () => import('../views/management/NewRequestView')
            },
            {
                path: 'edit-request',
                meta: {title: 'ویرایش درخواست', requiresAuth: true},
                name: 'EditRequestView',
                component: () => import('../views/management/EditRequestView')
            },
            {
                path: 'shifts',
                meta: {title: 'مدیریت شیفت‌ها', requiresAuth: true, permission:'SHIFT_LIST'},
                name: 'ShiftManagement',
                component: () => import('../components/management/ShiftManagement')
            },
            {
                path: 'shifts/assignment',
                meta: {title: 'تخصیص شیفت', requiresAuth: true, permission:'SHIFT_ASSIGN_USER'},
                name: 'ShiftAssignment',
                component: () => import('../components/management/ShiftAssignment')
            },
            {
                path: 'shifts/live-monitoring',
                meta: {title: 'پایش زنده شیفت‌ها', requiresAuth: true, permission:'SHIFT_LIST'},
                name: 'LiveMonitoring',
                component: () => import('../components/management/LiveMonitoring')
            },
            {
                path: 'drafts/qarecords',
                meta: {title: 'پیام‌های صوتی', requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'qa_records',
                component: () => import('../components/management/drafts/qarecords')
            },
            {
                path: 'drafts/portal',
                meta: {title: 'درخواست‌های پرتال', requiresAuth: true,permission:'VOICE_MAIL_LIST', requiredFeatures: ['workflow_management']},
                name: 'portal_c',
                component: () => import('../components/management/drafts/portal')
            },
            {
                path: 'drafts/paw',
                meta: {title: 'پیش نویس‌های پاو', requiresAuth: true, permission: 'VOICE_MAIL_LIST'},
                name: 'paw_c',
                component: () => import('../components/management/drafts/paw')
            },
            {
                path: 'drafts/forms',
                meta: {title: 'پیش نویس فرم ها',
                    requiresAuth: true,
                    permission:'TASK_FORM_LIST'
               },
                name: 'form_draft',
                component: () => import('../components/management/drafts/formDraft')
            },
            {
                path: 'drafts/telegram',
                meta: {title: 'پیام‌های تلگرام', requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'telegram_c',
                component: () => import('../components/management/drafts/telegram')
            },
            {
                path: 'drafts/whatsapp',
                meta: {title: 'پیام‌های واتس‌اپ', requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'whatsapp_c',
                component: () => import('../components/management/drafts/whatsapp')
            },
            {
                path: 'drafts/instagram',
                meta: {title: 'پیام‌های اینستاگرام', requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'instagram_c',
                component: () => import('../components/management/drafts/instagram')
            },
            {
                path: 'drafts/bale',
                meta: {title: 'پیام‌های بله', requiresAuth: true,permission:'VOICE_MAIL_LIST'},
                name: 'bale_c',
                component: () => import('../components/management/drafts/bale')
            },
            {
                path: 'drafts/sms',
                name: 'sms_c',
                meta: {title: 'پیامک‌ها', requiresAuth: true,permission:'VOICE_MAIL_LIST'},

                component: () => import( '../components/management/drafts/sms')
            },
            {
                path: 'field-management/:id?',
                meta: {title: 'مدیریت فیلدها', requiresAuth: true , permission:'TASK_FORM_LIST'},
                name: 'FieldManagement',
                component: () => import('../components/management/formManage/Fields')
            },
            {
                path: 'field-management/add-role/:id/:ruleId?',
                meta: {title: 'قوانین فیلدها', requiresAuth: true , permission:'TASK_FORM_LIST'},
                name: 'AddRole',
                component: () => import('../components/management/formManage/AddRole')
            },
            {
                path: 'call-notifier',
                meta: {title: 'اعلان تماس', requiresAuth: true},
                name: 'CallNotifier',
                component: () => import('../components/management/CallNotifier')
            },
            {
                path: 'call-notifier-logs/:id?',
                meta: {title: 'گزارش اعلان تماس', requiresAuth: true},
                name: 'CallNotifierLogs',
                component: () => import('../components/management/CallNotifierLogs')
            },

            {
                path: 'payslips',
                name: 'PayslipsComponent',
                meta: {title: 'فیش‌های حقوقی', requiresAuth: true, requiredFeatures: ['salaryInfo']},
                component: () => import('../components/management/PayslipsComponent.vue')
            },
            {
                path: 'system-links',
                name: 'SystemLinksComponent',
                meta: {title: 'سامانه‌ها', requiresAuth: true},
                component: () => import('../components/management/SystemLinksComponent.vue')
            },
            {
                path: 'contact-management',
                meta: {title: 'مدیریت مخاطبین', requiresAuth: true, permission:'CONTACT_LIST'},
                name: 'ContactComponent',
                component: () => import('../components/management/ContactComponent'),

            },
            {
                path: 'letters',
                meta: {title: 'نامه‌ها', requiresAuth: true, permission: 'LETTER_FOLLOW_UP_LIST'},
                name: 'LetterFollowUps',
                component: () => import('../components/management/LetterFollowUps.vue')
            },
            {
                path: 'contact-management/history/:id',
                meta: {title: 'تاریخچه مخاطب', requiresAuth: true, permission:'CONTACT_LIST'},
                name: 'ContactHistory',
                component: () => import('../components/management/ContactHistory')
            },


            {
                path: 'reports',
                /*  meta: {requiresAuth: true},*/
                children: [
                    {
                        path: 'all-reports',
                        meta: {title: 'گزارش‌ها', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'ReportsComponent',
                        component: () => import('../components/management/reports/ReportsComponent')
                    },
                    {
                        path: 'expert-performance',
                        meta: {title: 'عملکرد کارشناسان', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'ExpertPerformance',
                        component: () => import('../components/management/reports/ExpertPerformance')
                    },
                    {
                        path: 'expert-department',
                        meta: {title: 'عملکرد دپارتمان‌ها', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'ExpertDepartment',
                        component: () => import('../components/management/reports/ExpertDepartment')
                    },
                    {
                        path: 'comparative',
                        meta: {title: 'گزارش مقایسه‌ای', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'ComparativeComponent',
                        component: () => import('../components/management/reports/ComparativeComponent')
                    },
                    {
                        path: 'sla',
                        meta: {title: 'گزارش سطح خدمات', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'SlaComponent',
                        component: () => import('../components/management/reports/SlaComponent')
                    },
                    {
                        path: 'poll-report',
                        meta: {title: 'گزارش نظرسنجی', requiresAuth: true, permission:'REPORT_POLL_LIST'},
                        name: 'PollReport',
                        component: () => import('../components/management/reports/PollReport')
                    },
                    {
                        path: 'passenger-analysis',
                        name: 'PassengerAnalysis',
                        meta: {title: 'تحلیل مراجعین', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},

                        component: () => import( '../components/management/reports/PassengerAnalysis')
                    },
                    {
                        path: 'customer-analysis',
                        name: 'CustomerAnalysis',
                        meta: {title: 'تحلیل مشتریان', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},

                        component: () => import( '../components/management/reports/CustomerAnalysis')
                    },
                    {
                        path: 'call-monitor',
                        meta: {title: 'پایش تماس‌ها', requiresAuth: true, permission:'REPORT_GENERAL_LIST'},
                        name: 'CallMonitor',
                        component: () => import('../components/management/callMonitoring/CallMonitor')
                    },

                ]

            },

        ]
    },
    {
        path: '/auth',
        meta: {requiresAuth: false , withoutLayout: true, title: 'صفحه ورود'},
        children: [
            {
                path: 'login',
                name: 'LoginComponent',
                component:hadafmandi ? LoginHadafmandi : Login,
            },
            {
                path: 'password',
                meta: {title: 'ورود با رمز عبور'},
                name: 'PasswordComponent',
                component: Password,
            }, {
                path: 'otp',
                meta: {title: 'ورود با رمز یک‌بارمصرف'},
                component: Otp,
            }, {
                path: 'forget-password',
                meta: {title: 'بازیابی رمز عبور'},
                component: forget,
            }, {
                path: 'choice-password',
                name:'newPassword',
                meta: {title: 'انتخاب رمز عبور جدید',requiresAuth: false},
                component: NewPassword,
            }, {
                path: 'check-login',
                name: 'CheckLogin',
                component: CheckLogin,
                meta: {title: 'بررسی ورود', requiresAuth: false},
            },

        ],
    },
    {
        path: '/call-center',
        meta: {title: 'مرکز تماس', requiresAuth: true, withoutLayout: false},
        children: [
            {
                path: 'dashboard',
                meta: {title: 'داشبورد', requiresAuth: true},
                name: 'CallQueueMonitoring',
                component: () => import('../components/callCenter/CallCenterReports.vue'),

            },
            {
                path: 'monitoring',
                meta: {title: 'مانیتورینگ', requiresAuth: true},
                name: 'CallCenterMonitoring',
                component: () => import('../components/callCenter/CallCenterMonitoring.vue'),
            },
            {
                path: 'call-audio-archive',
                meta: {title: 'آرشیو صدای تماس‌ها', requiresAuth: true},
                name: 'CallAudioArchive',
                component: () => import('../components/callCenter/CallAudioArchive'),

            },
            {
                path: 'extensions',
                meta: {title: 'داخلی‌ها', requiresAuth: true},
                name: 'Extensions',
                component: () => import('../components/callCenter/ExtensionsComponent'),
            },
            {
                path: 'queues',
                meta: {title: 'صف‌های تماس', requiresAuth: true},
                name: 'Queues',
                component: () => import('../components/callCenter/QueueListComponent'),
            },
            {
                path: 'queues/:id',
                meta: {title: 'جزئیات صف تماس', requiresAuth: true},
                name: 'queue-details',
                component: () => import('../components/callCenter/QueuesComponent'),
            },
            {
                path: 'ivr',
                meta: {title: 'تلفن گویا', requiresAuth: true},
                name: 'IvrComponent',
                component: () => import('../components/callCenter/IvrComponent'),
            },
            {
                path: 'cdr',
                meta: {title: 'گزارش تماس‌ها', requiresAuth: true},
                name: 'cdr',
                component: () => import('../components/callCenter/CdrReportComponent'),
            },
            {
                path: 'trunks',
                meta: {title: 'ترانک‌ها', requiresAuth: true},
                name: 'TrunksComponent',
                component: () => import('../components/callCenter/TrunksComponent'),
            },
            {
                path: 'missed-calls',
                meta: {title: 'تماس‌های بی‌پاسخ', requiresAuth: true},
                name: 'MissedCallsComponent',
                component: () => import('../components/callCenter/MissedCallsComponent'),
            },
        ]
    },
    {
        path: '/error/error-503',
        name: 'Error503',
        component: Error503View,
        meta: {title: 'سرویس در دسترس نیست', requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/error/error-403',
        name: 'Error403',
        component: Error403View,
        meta: {title: 'دسترسی غیرمجاز', requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/error/error-401',
        name: 'Error401',
        component: () => import( '../views/Error401View.vue'),
        meta: {title: 'نیاز به ورود', requiresAuth: false,withoutLayout: true},
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: Error404View,
        meta: {title: 'صفحه پیدا نشد', requiresAuth: false,withoutLayout: true},
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

let accessMenus = {
    portal: false,
    workflow_management: false,
    artificial_intelligence: false,
}
let features = []

import store from "@/store";
import { useUserStore } from '@/store/user'
router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore()
    if (userStore.userInfo) {
        let data = userStore.userInfo
        features = data?.data?.features

    }

    const updateSettings = () => {
        Object.keys(accessMenus).forEach((key) => {
            const featureName = key.replace(/^is/, '').toLowerCase();
            accessMenus[key] = features?.some((feature) => feature.name && feature.name.toLowerCase() === featureName);
        });

    };
    updateSettings();
    /*if (to.fullPath.includes('auth') || to.fullPath.includes('error')) {
        store.commit('setWithoutLayout', true)
    } else {
        store.commit('setWithoutLayout', false)
    }*/

    if (to.fullPath.includes('management')) {
        store.commit('setPanelRole', '0')
        localStorage.setItem('panel-role', '0')
    } else if (to.fullPath.includes('admin')) {
        store.commit('setPanelRole', '1')
        localStorage.setItem('panel-role', '1')
    }

    const isAuthenticated = !!localStorage.getItem('token')
    const requiresAuth = to.matched.some(r => r.meta?.requiresAuth === true)



    if (requiresAuth && !isAuthenticated) {
        return next('/auth/login')
    }

    const requiresAdmin = to.matched.some(r => r.meta?.requiresAdmin === true)

    if (requiresAdmin) {
        try {
            await userStore.loadUser(localStorage.getItem('token'))

            const hasAdminPermission = userStore.userInfo?.data?.permissions?.some(
                item => item.category === 'system'
            )

            if (!hasAdminPermission) {
                return next({name: 'DashboardManagement'})
            }

            store.commit('setPanelRole', '1')
            localStorage.setItem('panel-role', '1')
        } catch (error) {
            return next({name: 'Error403'})
        }
    }

    if (!requiresAuth && isAuthenticated && to.fullPath.includes('/auth')) {
        if (to.name === 'newPassword') {
            return next()
        }
        return next('/')
    }

    /*const requiredFeatures = to.meta.requiredFeatures || []
    if (requiredFeatures.length) {
        const hasAccess = requiredFeatures.every(f => accessMenus[f])
        if (!hasAccess) {
            return next('/error/error-403')
        }
    }
     const userInfo = JSON.parse(localStorage.getItem('userInfo'))
     const userPermissions = computed(() => {
         return userInfo.data.permissions.flatMap(cat =>
             cat.permissions.map(p => p.name)
         )
     })

     if (to.meta.permission) {

         if (!userPermissions.value.includes(to.meta.permission)) {
             return next({ name: "Error403" })
         }

     }*/

    next()
})


export default router
